export default "/assets/images/gamer-room-video.mp4?6715151f52300ad239b28d3cb1dea935";